// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___1NREN","skeleton-loading":"styles__skeleton-loading___30yem","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___oWSWn","skeleton-loader-gradient":"styles__skeleton-loader-gradient___3zo-1","mainSectionSkeleton":"styles__mainSectionSkeleton___2dFaj","skeletonText":"styles__skeletonText___Ec6KQ","table":"styles__table___DEStu","header":"styles__header___U1l3v","tableHeader":"styles__tableHeader___BB9DN","itemValue":"styles__itemValue___1QDi6","tableBody":"styles__tableBody___3bGte","button":"styles__button___212uY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/ScheduleOnlineInterfaceSkeleton/styles.css
// module id = 2544
// module chunks = 0